import MarketReportTable from './MarketReportTable';
export default MarketReportTable;
